function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useDeferredValue, useRef } from 'react';
import { deleteCustomCommand, getCustomCommands } from '@/actions/CommandActions';
import Table from '@/components/Table';
import { ActionIcon, Button, Table as MantineTable, Menu, Text } from '@mantine/core';
import AliasResponse from '@/components/AliasResponse';
import UserLevelTag from '@/components/UserLevelTag';
import { faEllipsisV, faPencil, faTrash } from '@fortawesome/free-solid-svg-icons';
import InputModal from '@/components/InputModal';
import TableHeading from '@/components/TableHeading';
import { getUserLevelValue } from '@/utils/userlevel';
import { CommandsLayoutContext } from '@/components/layouts/CommandsLayout';
import useCustomCommandStore from '@/stores/CustomCommandStore';
import useChannelStore from '@/stores/ChannelStore';
import { useLimitQueryState, usePageQueryState, useSortDirectionQueryState } from '@/hooks/usePaginationQueryState';
import { LordIconSizes, SortDirections } from '@/types/client';
import EmptyState from '@/components/EmptyState';
import useQueryState from '@/hooks/useQueryState';
import { FormattedMessage, useIntl } from 'react-intl';
import Pagination from '../Pagination';
import { useNavigate } from 'react-router';
import { useShallow } from 'zustand/react/shallow';
import { DynamicWebRoutes, WebRoutes } from '@/utils/constants';
import styles from './CommandsCustom.module.scss';
import Icon, { IconSizes } from '../Icon';
import { useDisclosure } from '@mantine/hooks';
import TargetDropdown from '../TargetDropdown';
import FolderPlus from '../icons/lord/FolderPlus';
var HeadingKeys;
(function(HeadingKeys) {
    HeadingKeys["COMMAND"] = "command";
    HeadingKeys["MESSAGE"] = "message";
    HeadingKeys["USER_LEVEL"] = "userLevel";
})(HeadingKeys || (HeadingKeys = {}));
var _obj;
var SortFunctions = (_obj = {}, _define_property(_obj, "command", function(a, b) {
    return a.name.localeCompare(b.name);
}), _define_property(_obj, "message", function(a, b) {
    return a.message.localeCompare(b.message);
}), _define_property(_obj, "userLevel", function(a, b) {
    return getUserLevelValue(a.userLevel) - getUserLevelValue(b.userLevel);
}), _obj);
function CommandHeader(param) {
    var sortBy = param.sortBy, sortDirection = param.sortDirection, setSortDirection = param.setSortDirection, setSortBy = param.setSortBy;
    function handleSortChange(key, direction) {
        setSortBy(direction != null ? key : null);
        setSortDirection(direction);
    }
    return /*#__PURE__*/ _jsxs(MantineTable.Tr, {
        children: [
            /*#__PURE__*/ _jsx(TableHeading, {
                active: sortBy === "command",
                sort: sortDirection,
                setSort: function(sortDirection) {
                    return handleSortChange("command", sortDirection);
                },
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "9WyylR",
                    defaultMessage: "Command"
                })
            }),
            /*#__PURE__*/ _jsx(TableHeading, {
                visibleFrom: "sm",
                active: sortBy === "message",
                sort: sortDirection,
                setSort: function(sortDirection) {
                    return handleSortChange("message", sortDirection);
                },
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "T7Ry38",
                    defaultMessage: "Message"
                })
            }),
            /*#__PURE__*/ _jsx(TableHeading, {
                visibleFrom: "sm",
                alignRight: true,
                active: sortBy === "userLevel",
                sort: sortDirection,
                setSort: function(sortDirection) {
                    return handleSortChange("userLevel", sortDirection);
                },
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "hqByQG",
                    defaultMessage: "User-Level"
                })
            }),
            /*#__PURE__*/ _jsx(TableHeading, {
                visibleFrom: "sm",
                alignRight: true,
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "wL7VAE",
                    defaultMessage: "Actions"
                })
            })
        ]
    });
}
var MemoizedCommandHeader = /*#__PURE__*/ React.memo(CommandHeader);
function CommandRow(param) {
    var command = param.command, parentOnDelete = param.onDelete, parentOnEdit = param.onEdit, setMenuData = param.setMenuData;
    var intl = useIntl();
    var ref = useRef(null);
    var onDelete = React.useCallback(function() {
        return parentOnDelete(command._id);
    }, [
        parentOnDelete,
        command._id
    ]);
    var onEdit = React.useCallback(function() {
        return parentOnEdit(command._id);
    }, [
        parentOnEdit,
        command._id
    ]);
    return /*#__PURE__*/ _jsxs(MantineTable.Tr, {
        children: [
            /*#__PURE__*/ _jsx(MantineTable.Td, {
                className: styles.commandName,
                children: /*#__PURE__*/ _jsxs("div", {
                    className: styles.commandStack,
                    children: [
                        /*#__PURE__*/ _jsx(Text, {
                            size: "sm",
                            className: styles.commandName,
                            children: command.name
                        }),
                        /*#__PURE__*/ _jsx(AliasResponse, {
                            size: "sm",
                            containerProps: {
                                className: styles.commandAliasResponse
                            },
                            alias: command.alias,
                            response: command.message
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(MantineTable.Td, {
                visibleFrom: "sm",
                className: styles.commandMessageColumn,
                children: /*#__PURE__*/ _jsx(AliasResponse, {
                    size: "sm",
                    alias: command.alias,
                    response: command.message
                })
            }),
            /*#__PURE__*/ _jsx(MantineTable.Td, {
                visibleFrom: "sm",
                className: styles.commandUserLevelColumn,
                children: /*#__PURE__*/ _jsx(UserLevelTag, {
                    showIcon: false,
                    userLevel: command.userLevel
                })
            }),
            /*#__PURE__*/ _jsx(MantineTable.Td, {
                children: /*#__PURE__*/ _jsxs("div", {
                    className: styles.actionIcons,
                    children: [
                        /*#__PURE__*/ _jsx(ActionIcon, {
                            visibleFrom: "sm",
                            size: "xs",
                            "aria-label": intl.formatMessage({
                                id: "dGRQmn",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Edit Command"
                                    }
                                ]
                            }),
                            onClick: onEdit,
                            children: /*#__PURE__*/ _jsx(Icon, {
                                size: IconSizes.SM,
                                icon: faPencil
                            })
                        }),
                        /*#__PURE__*/ _jsx(ActionIcon, {
                            visibleFrom: "sm",
                            size: "xs",
                            "aria-label": intl.formatMessage({
                                id: "FXZoo8",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Delete Command"
                                    }
                                ]
                            }),
                            onClick: onDelete,
                            children: /*#__PURE__*/ _jsx(Icon, {
                                size: IconSizes.SM,
                                icon: faTrash
                            })
                        }),
                        /*#__PURE__*/ _jsx(ActionIcon, {
                            size: "md",
                            hiddenFrom: "sm",
                            "aria-label": intl.formatMessage({
                                id: "dGRQmn",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Edit Command"
                                    }
                                ]
                            }),
                            onClick: function() {
                                return setMenuData({
                                    command: command,
                                    targetRef: ref
                                });
                            },
                            ref: ref,
                            children: /*#__PURE__*/ _jsx(Icon, {
                                size: IconSizes.MD,
                                icon: faEllipsisV
                            })
                        })
                    ]
                })
            })
        ]
    });
}
var MemoizedCommandRow = /*#__PURE__*/ React.memo(CommandRow);
function CommandsCustom() {
    var intl = useIntl();
    var channel = useChannelStore(function(state) {
        return state.channel;
    });
    var _React_useState = _sliced_to_array(React.useState(null), 2), selectedCommandId = _React_useState[0], setSelectedCommandId = _React_useState[1];
    var navigate = useNavigate();
    var buttonRef = useRef(null);
    var _React_useState1 = _sliced_to_array(React.useState(null), 2), menuData = _React_useState1[0], setMenuData = _React_useState1[1];
    var _useCustomCommandStore = useCustomCommandStore(useShallow(function(state) {
        return {
            isLoading: state.isLoading,
            commands: channel != null ? state.getCommandsForChannel(channel._id) : null,
            command: channel != null && selectedCommandId != null ? state.getCommand(channel._id, selectedCommandId) : null
        };
    })), isLoading = _useCustomCommandStore.isLoading, commands = _useCustomCommandStore.commands, command = _useCustomCommandStore.command;
    var _useDisclosure = _sliced_to_array(useDisclosure(), 2), deleteCommandModalOpen = _useDisclosure[0], deleteCommandModalHandlers = _useDisclosure[1];
    var search = React.useContext(CommandsLayoutContext);
    var deferredSearch = useDeferredValue(search);
    var _useSortDirectionQueryState = _sliced_to_array(useSortDirectionQueryState(), 2), sortDirection = _useSortDirectionQueryState[0], setSortDirection = _useSortDirectionQueryState[1];
    var _useQueryState = _sliced_to_array(useQueryState('sortBy', {
        defaultValue: "command"
    }), 2), sortBy = _useQueryState[0], setSortBy = _useQueryState[1];
    var _usePageQueryState = _sliced_to_array(usePageQueryState(), 2), page = _usePageQueryState[0], setPage = _usePageQueryState[1];
    var _useLimitQueryState = _sliced_to_array(useLimitQueryState(), 2), limit = _useLimitQueryState[0], setLimit = _useLimitQueryState[1];
    React.useEffect(function() {
        if (isLoading || channel == null) {
            return;
        }
        getCustomCommands(channel._id).catch(console.error);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        channel
    ]);
    var sortedCommands = React.useMemo(function() {
        var sortedCommands = commands;
        if (sortedCommands == null) {
            return null;
        }
        if (deferredSearch.length > 0) {
            var normalizedQuery = deferredSearch.toLowerCase();
            sortedCommands = sortedCommands.filter(function(command) {
                return command.name.toLowerCase().includes(normalizedQuery) || command.message.toLowerCase().includes(normalizedQuery);
            });
        }
        var sortFn = sortBy != null ? SortFunctions[sortBy] : null;
        if (sortFn == null) {
            return sortedCommands;
        }
        sortedCommands = _to_consumable_array(sortedCommands);
        return sortDirection === SortDirections.ASC ? sortedCommands.sort(sortFn) : sortedCommands.sort(function(a, b) {
            return -sortFn(a, b);
        });
    }, [
        commands,
        deferredSearch,
        sortDirection,
        sortBy
    ]);
    var handleDelete = React.useCallback(function(commandId) {
        setSelectedCommandId(commandId);
        deleteCommandModalHandlers.open();
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        deleteCommandModalHandlers.open
    ]);
    var handleEdit = React.useCallback(function(commandId) {
        return navigate(DynamicWebRoutes.COMMANDS_CUSTOM_EDIT(commandId));
    }, [
        navigate
    ]);
    var handleConfirmDelete = React.useCallback(/*#__PURE__*/ _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (command == null || channel == null) {
                        return [
                            2
                        ];
                    }
                    return [
                        4,
                        deleteCustomCommand(channel._id, command._id)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    }), [
        command,
        channel
    ]);
    var slicedCommands = React.useMemo(function() {
        if (sortedCommands == null) {
            return null;
        }
        return sortedCommands.slice(page * limit, (page + 1) * limit);
    }, [
        sortedCommands,
        page,
        limit
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Table, {
                data: slicedCommands,
                extraData: [
                    navigate,
                    setMenuData,
                    handleDelete,
                    handleEdit,
                    page,
                    limit,
                    sortDirection,
                    sortBy
                ],
                renderFooter: function() {
                    var _sortedCommands_length;
                    return /*#__PURE__*/ _jsx(Pagination, {
                        limit: limit,
                        page: page,
                        total: (_sortedCommands_length = sortedCommands === null || sortedCommands === void 0 ? void 0 : sortedCommands.length) !== null && _sortedCommands_length !== void 0 ? _sortedCommands_length : 0,
                        setLimit: setLimit,
                        nextPage: function() {
                            return setPage(page + 1);
                        },
                        previousPage: function() {
                            return setPage(page - 1);
                        }
                    });
                },
                renderHeader: function() {
                    return /*#__PURE__*/ _jsx(MemoizedCommandHeader, {
                        sortDirection: sortDirection,
                        sortBy: sortBy,
                        setSortDirection: setSortDirection,
                        setSortBy: setSortBy
                    });
                },
                renderRow: function(command) {
                    return /*#__PURE__*/ _jsx(MemoizedCommandRow, {
                        command: command,
                        onDelete: handleDelete,
                        onEdit: handleEdit,
                        setMenuData: setMenuData
                    });
                },
                renderEmptyState: function() {
                    return /*#__PURE__*/ _jsx(EmptyState, {
                        title: intl.formatMessage({
                            id: "CokBda",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Custom Commands"
                                }
                            ]
                        }),
                        description: intl.formatMessage({
                            id: "rdp+r7",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Commands are used to trigger responses in chat, start by creating a new command."
                                }
                            ]
                        }),
                        icon: /*#__PURE__*/ _jsx(FolderPlus, {
                            groupRef: buttonRef,
                            trigger: "hover",
                            size: LordIconSizes.LARGE
                        }),
                        buttons: [
                            /*#__PURE__*/ _jsx(Button, {
                                ref: buttonRef,
                                onClick: function() {
                                    return navigate(WebRoutes.COMMANDS_CUSTOM_CREATE);
                                },
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "2xN+AO",
                                    defaultMessage: "New Command"
                                })
                            }, "new-command")
                        ]
                    });
                }
            }),
            /*#__PURE__*/ _jsx(InputModal, {
                title: intl.formatMessage({
                    id: "FXZoo8",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Delete Command"
                        }
                    ]
                }),
                description: intl.formatMessage({
                    id: "czdje2",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Are you sure you want to delete this command?"
                        }
                    ]
                }),
                isOpen: deleteCommandModalOpen,
                onClose: deleteCommandModalHandlers.close,
                onSubmit: handleConfirmDelete,
                submitText: intl.formatMessage({
                    id: "K3r6DQ",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Delete"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs(TargetDropdown, {
                position: "bottom-end",
                targetRef: menuData === null || menuData === void 0 ? void 0 : menuData.targetRef,
                opened: menuData != null,
                dropdownProps: {
                    hiddenFrom: 'sm'
                },
                onClose: function() {
                    return setMenuData(null);
                },
                children: [
                    /*#__PURE__*/ _jsx(Menu.Label, {
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "wL7VAE",
                            defaultMessage: "Actions"
                        })
                    }),
                    /*#__PURE__*/ _jsxs(React.Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(Menu.Item, {
                                onClick: function() {
                                    return handleEdit(menuData.command._id);
                                },
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "dGRQmn",
                                    defaultMessage: "Edit Command"
                                })
                            }),
                            /*#__PURE__*/ _jsx(Menu.Item, {
                                color: "red",
                                onClick: function() {
                                    return handleDelete(menuData.command._id);
                                },
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "FXZoo8",
                                    defaultMessage: "Delete Command"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
export default CommandsCustom;
